import { render, staticRenderFns } from "./ServiceToday.vue?vue&type=template&id=82a0d64c&scoped=true&"
import script from "./ServiceToday.vue?vue&type=script&lang=js&"
export * from "./ServiceToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a0d64c",
  null
  
)

export default component.exports